import { render, staticRenderFns } from "./ValueDisplay.vue?vue&type=template&id=25b3de8d&scoped=true&"
import script from "./ValueDisplay.vue?vue&type=script&lang=ts&"
export * from "./ValueDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./ValueDisplay.vue?vue&type=style&index=0&id=25b3de8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b3de8d",
  null
  
)

export default component.exports